/** The depth endpoint refuses an hourly window longer than this, inclusive. */
export const MAX_HOURLY_DEPTH_DAYS = 31;

const MS_PER_DAY = 86_400_000;

function parseDay(day: string): Date {
    return new Date(`${day}T00:00:00Z`);
}

function formatDay(date: Date): string {
    return date.toISOString().slice(0, 10);
}

function addDays(day: string, days: number): string {
    const date = parseDay(day);
    date.setUTCDate(date.getUTCDate() + days);
    return formatDay(date);
}

/**
 * The hourly request, shortened to {@link MAX_HOURLY_DEPTH_DAYS} when the range is longer.
 *
 * `clamped` is what the page uses to say the start was moved. A missing end is today.
 */
export function clampHourlyRange(
    from: string | undefined,
    to: string | undefined,
    today: string
): { from: string; to: string; clamped: boolean } {
    const end = to && to >= '1970-01-02' ? to : today;
    const start = from && from <= end ? from : end;
    const span = Math.round((parseDay(end).getTime() - parseDay(start).getTime()) / MS_PER_DAY) + 1;
    if (span <= MAX_HOURLY_DEPTH_DAYS) {
        return { from: start, to: end, clamped: start !== from || end !== to };
    }
    return { from: addDays(end, -(MAX_HOURLY_DEPTH_DAYS - 1)), to: end, clamped: true };
}
